import React, { useEffect } from 'react';
import OvertimeTotalDataTable from './OvertimeTotalDataTable';

const OvertimeTotalIndex = ({ rrhh }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <OvertimeTotalDataTable rrhh={rrhh} />;
};

export default OvertimeTotalIndex;
